import { render, staticRenderFns } from "./left-tool.vue?vue&type=template&id=2804e438&scoped=true&"
import script from "./left-tool.vue?vue&type=script&lang=js&"
export * from "./left-tool.vue?vue&type=script&lang=js&"
import style0 from "./left-tool.vue?vue&type=style&index=0&id=2804e438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2804e438",
  null
  
)

export default component.exports